import * as dayjs from "dayjs";

export const generateTimeline = (initialDate, finalDate) => {
  let datas = [];
  let increment = dayjs(initialDate).startOf("minute").toDate();
  const final = dayjs(finalDate).startOf("minute").toDate();

  for (
    ;
    dayjs(increment) < final;
    increment = dayjs(increment).add(1, "minute").toDate()
  ) {
    datas.push(increment);
  }

  return datas;
};
